import CallCenterTickets from "./CallCenterTickets";

const CallCenterTicketsConfig = {
	settings: {},
	routes: [
		{
			path: '/apps/callcenter/tickets',
			component: CallCenterTickets
		}
	]
};

export default CallCenterTicketsConfig;
